import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=bfa5df02&scoped=true&"
import script from "./step2.vue?vue&type=script&lang=js&"
export * from "./step2.vue?vue&type=script&lang=js&"
import style0 from "./step2.vue?vue&type=style&index=0&id=bfa5df02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa5df02",
  null
  
)

export default component.exports